import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Play',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M4 22V2l20 10z", fill: "currentColor" }
      })]
    );
  }
};